import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClaimRow } from '../../../../models/api/view/claim-view/claim-row';
import { BaseComponent } from '../../../base/base.component';
import { SelectComponent } from '../../../core/controls/select.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { CardComponent } from '../../../core/panels/card.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';

import { getClaimKey } from '../../../../functions/get-claim-key';
import { JobHistoryFinancial } from '../../../../models/api/view/claim/hr/job-history/job-history-financial';
import { JobHistoryListItem } from '../../../../models/api/view/claim/hr/job-history/job-history-list-item';
import {
  JobHistoryBenefitPlan,
  JobHistoryResponse,
} from '../../../../models/api/view/claim/hr/job-history/job-history-response';

@Component({
  selector: 'app-job-history',
  imports: [
    RouterModule,
    DetailPanelComponent,
    DetailItemComponent,
    PageHeaderComponent,
    SelectComponent,
    CardComponent,
    TableComponent,
    ColumnComponent,
  ],
  template: `
    <app-page-header label="Job history">
      <ng-template #right>
        <div class="tw-w-64">
          <app-select
            [control]="effectiveDate"
            [options]="asOfDateList"
            optionLabel="key"
            optionValue="value"
            [multiple]="false"
            [showClear]="false"
            [showHelpText]="false"
            (change)="onSelectChange($event)"
            label="As of"
          ></app-select>
        </div>
      </ng-template>
    </app-page-header>
    @if (this.asOfDateList?.length > 0) {
      <div class=" tw-w-full tw-gap-8 tw-px-4">
        @if (this.asOfDateList.length > 0) {
          <app-card label="Job">
            <div class="tw-flex tw-w-full tw-gap-8">
              <app-detail-panel
                class="tw-grow"
                [dataSource]="jobHistory"
                [showEmpty]="false"
              >
                <app-detail-item
                  label="Date effective"
                  name="dateEffective"
                  format="d"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Action code"
                  name="actionCode"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Position date"
                  name="positionDate"
                  format="d"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Length of service"
                  name="lengthOfService"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Employee status"
                  name="employeeStatus"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="FLSA status"
                  labelCase="none"
                  name="flsaStatus"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Union code"
                  name="unionCode"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Supervisor employee ID"
                  labelCase="none"
                  name="supervisorEmployeeID"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Supervisor email"
                  name="supervisorEmail"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Employment basis"
                  name="employmentBasis"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Pay frequency"
                  name="payFrequency"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Hours/day"
                  name="hoursRegularDay"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Scheduled hours"
                  name="scheduledHours"
                  [showEmpty]="false"
                />
              </app-detail-panel>
              <app-detail-panel
                class="tw-grow"
                [dataSource]="jobHistory"
                [showEmpty]="false"
              >
                <app-detail-item
                  label="Date updated"
                  name="dateUpdated"
                  format="d"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Action date"
                  name="actionDate"
                  format="d"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Job title"
                  name="jobTitle"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Job group"
                  name="jobGroup"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Manager level"
                  name="managerLevel"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Employee class"
                  name="employeeClass"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Union local"
                  name="unionLocal"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Supervisor SSN"
                  labelCase="none"
                  name="supervisorSSN"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Employee type"
                  name="employeeType"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Pay group"
                  name="payGroup"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Hours/week"
                  name="hoursRegularWeek"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="shift"
                  name="shift"
                  [showEmpty]="false"
                />
              </app-detail-panel>
              <app-detail-panel
                class="tw-grow"
                [dataSource]="jobHistory"
                [showEmpty]="false"
              >
                <app-detail-item
                  label="Action reason"
                  name="actionReason"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Class code"
                  name="classCode"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Pay type"
                  name="payType"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Salary grade"
                  name="salaryGrade"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Days/week"
                  name="daysRegularWeek"
                  [showEmpty]="false"
                />
              </app-detail-panel>
            </div>
          </app-card>
        }
      </div>

      <div class="tw-flex tw-gap-8 tw-px-4 tw-pt-6">
        <div class="tw-basis-2/3">
          @if (this.asOfDateList.length > 0) {
            <app-card label="company">
              <div class="tw-flex tw-w-full tw-gap-8">
                <app-detail-panel
                  class="tw-grow"
                  [dataSource]="jobHistory"
                  [showEmpty]="false"
                >
                  <app-detail-item
                    label="Company code"
                    name="companyCode"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Transfer code"
                    name="transferCode"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Business unit"
                    name="businessUnit"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Bargained"
                    name="bargained"
                    [showEmpty]="false"
                    format="b"
                  />
                  <app-detail-item
                    label="Responsibility"
                    name="responsibility"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Organization ID"
                    labelCase="none"
                    name="organizationID"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Department ID"
                    labelCase="none"
                    name="departmentID"
                    [showEmpty]="false"
                  />
                </app-detail-panel>
                <app-detail-panel
                  class="tw-grow"
                  [dataSource]="jobHistory"
                  [showEmpty]="false"
                >
                  <app-detail-item
                    label="Location code"
                    name="locationCode"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Job code"
                    name="jobCode"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Business unit name"
                    name="businessUnitName"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Bargained unit"
                    name="bargainedUnit"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Regulated"
                    name="regulated"
                    [showEmpty]="false"
                    format="b"
                  />
                  <app-detail-item
                    label="Organization name"
                    name="organizationName"
                    [showEmpty]="false"
                  />
                  <app-detail-item
                    label="Department name"
                    name="departmentName"
                    [showEmpty]="false"
                  />
                </app-detail-panel>
              </div>
            </app-card>
          }
        </div>

        @if (isHRFinancialAuthorized) {
          <div class="tw-basis-1/3">
            @if (this.asOfDateList?.length > 0) {
              <app-card label="Financials">
                <div class="tw-flex tw-w-full tw-gap-8">
                  <app-detail-panel
                    class="tw-grow"
                    [dataSource]="jobHistoryFinancial"
                    [showEmpty]="false"
                  >
                    <app-detail-item
                      label="Hourly base pay"
                      name="hourlyBasePay"
                      format="c"
                      [showEmpty]="false"
                      [zeroEmpty]="true"
                    />
                    <app-detail-item
                      label="Weekly base pay"
                      name="weeklyBasePay"
                      format="c"
                      [showEmpty]="false"
                      [zeroEmpty]="true"
                    />
                    <app-detail-item
                      label="Monthly base pay"
                      name="monthlyBasePay"
                      format="c"
                      [showEmpty]="false"
                      [zeroEmpty]="true"
                    />
                    <app-detail-item
                      label="Yearly base pay"
                      name="yearlyBasePay"
                      format="c"
                      [showEmpty]="false"
                      [zeroEmpty]="true"
                    />
                    <app-detail-item
                      label="Average daily commission rate"
                      name="avgDailyCommissionRate"
                      format="c"
                      [showEmpty]="false"
                      [zeroEmpty]="true"
                    />
                    <app-detail-item
                      label="Other income"
                      name="otherIncome"
                      format="c"
                      [showEmpty]="false"
                      [zeroEmpty]="true"
                    />
                    <app-detail-item
                      label="Frequency"
                      name="frequency"
                      [showEmpty]="false"
                    />
                    <app-detail-item
                      label="Weekly PT earnings"
                      name="weeklyPtEarnings"
                      format="c"
                      labelCase="none"
                      [showEmpty]="false"
                      [zeroEmpty]="true"
                    />
                  </app-detail-panel>
                </div>
              </app-card>
            }
          </div>
        }
      </div>
      <div class="tw-w-full tw-px-4 tw-pt-6">
        @if (this.asOfDateList?.length > 0) {
          <app-card label="benefit plan">
            <div class="tw-max-w-[30%] tw-pb-2">
              <app-detail-panel [dataSource]="jobHistory" [showEmpty]="false">
                <app-detail-item
                  label="benefit Code"
                  name="benefitCode"
                  [showEmpty]="false"
                />
                <app-detail-item
                  label="Employee buy up contribution"
                  name="employeeBuyUpContrib"
                  [showEmpty]="false"
                />
              </app-detail-panel>
            </div>
            <app-table
              [dataSource]="jobHistoryBenefitPlan"
              [pageSize]="5"
              [scrollable]="false"
              dataKey="id"
              recordLabel="Benefit plan"
            >
              <app-column name="type" label="Type" />
              <app-column name="name" label="Name" />
              <app-column name="dateEffective" label="Effective" format="d" />
              <app-column name="dateExpire" label="Expires" format="d" />
            </app-table>
          </app-card>
        }
      </div>
    } @else {
      <div class="tw-py-8 tw-text-center tw-text-gray-500">
        No job history data available.
      </div>
    }
  `,
  styles: ``,
})
export class JobHistoryComponent extends BaseComponent implements OnInit {
  claimRow: ClaimRow;
  jobHistory: JobHistoryResponse;
  asOfDateList: JobHistoryListItem[] = [];
  jobHistoryFinancial: JobHistoryFinancial;
  jobHistoryBenefitPlan: JobHistoryBenefitPlan[] = [];
  isHRFinancialAuthorized = false;
  asOfdate: Date;
  effectiveDate = new FormControl<string>('e');
  async ngOnInit() {
    this.view.showLoading();
    this.isHRFinancialAuthorized = this.session.authorize('HRFinancial');
    this.dispose.subs = this.effectiveDate.valueChanges.subscribe(
      (selectedDate: string) => {
        this.onSelectChange(selectedDate);
      },
    );
    const asOfDates = (
      await this.api.jobHistory.getJobHistoryAsOfNowDate(getClaimKey())
    ).asOfDate;
    // Filter for distinct values based on 'value' property
    this.asOfDateList = asOfDates.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.value === item.value),
    );
    if (this.asOfDateList.length > 0) {
      this.effectiveDate.setValue(this.asOfDateList[0].value, {
        emitEvent: false,
      });
      await this.onSelectChange(this.asOfDateList[0].value);
    }
    this.view.hideLoading();
  }

  async onSelectChange(value: any) {
    const claim = this.view.currentClaim();
    this.asOfdate = new Date(Date.parse(value));
    this.jobHistory = await this.api.jobHistory.get(
      getClaimKey(),
      claim.contractNumber,
      this.asOfdate,
    );
    if (this.isHRFinancialAuthorized) {
      this.jobHistoryFinancial =
        await this.api.jobHistory.getJobHistoryFinancial(
          getClaimKey(),
          this.asOfdate,
        );
    }

    this.jobHistoryBenefitPlan = this.jobHistory?.benefitPlans;
  }
}
